export default "__VITE_ASSET__6d1dd5e5__"